"use strict";

var HASH_ENCOUDING="%23"
define('components/filter_bar/storage/url_storage',['history'], function() {
    // NOTE: This is component makes direct, unscoped entries to window.location.search
    //
    // Filters are stored in the URL query string as `quantifiers.<type>=<filter_name>`.
    // For example, `quantifiers.none=tag&quantifiers.none=entity'
    // means that we want to filter for objects that are not tagged and
    // are not associated with any entities.
    var urlStorageComponent = {
        initWithContext: function(context) {
            if (!context.isInitialized()) {
                _initHistory(context);
            }

            var qs = window.location.search.substring(1) || context.buttonbarNode.data('initial-query-string');
            var baseUrl = context.buttonbarNode.data('base-url');
            _populateParamsFromQS(context, qs || '', baseUrl);

            context.onDirtyState(function(e, stateData, url) {
                History.pushState(stateData, document.title, url || _getQSFromParams(context));
            });
        },

        getQSFromParams: _getQSFromParams,
        populateParamsFromQS: _populateParamsFromQS
    };

    function _initHistory(context) {
        History.Adapter.bind(window, 'statechange', function() {
            var historyState = History.getState();
            var data = historyState.data;

            if (!data || data.component !== 'buttonbar') return;

            _populateParamsFromQS(context, window.location.search.substring(1).trim());
            context.markStateSaved();

            // Apply the button state if button data provided
            if (data.buttonSelector) {
                var button = context.buttonbarNode.find(data.buttonSelector);
                var isSelected = data.buttonState == 'selected';
                button.toggleClass('btn-selected', isSelected)
                      .toggleClass('btn-default', !isSelected);
            } else if (!context.hasAnyFilters()) {
                // If going back in history to unfiltered state, clear all button states
                context.buttonbarNode.find('button[data-filter-name]')
                                     .removeClass("btn-selected")
                                     .addClass("btn-default");
            }
        });
    }

    function _populateParamsFromQS(context, qs, baseUrl) {
        context.setParams(null);

        baseUrl = baseUrl ? baseUrl.trim() : null;
        context.setBaseUrl(baseUrl);

        qs = qs ? qs.trim() : '';
        if (!qs) return;

        qs.split('&').forEach(function(str) {
            var pair = str.split('=');
            var key = decodeURIComponent(pair[0]);
            var values = pair[1] ? decodeURIComponent(pair[1]).split('~') : [];
            if (values.length == 0) return;

            switch (key) {
                case 'sort':
                    var sortOrder = values[0].split('-');
                    context.setSortOrder(sortOrder);
                    return;

                case 'quantifiers.all':
                    values.forEach(function(filterName) {
                        context.setFilterQuantifier(filterName, 'all');
                    });
                    return;

                case 'quantifiers.none':
                    values.forEach(function(filterName) {
                        context.setFilterQuantifier(filterName, 'none');
                    });
                    return;
                
                // Throw away pagination param
                case 'p':
                    return;
                
                default:
                    values.forEach(function(value) {
                        context.applyFilter(key, value);
                    });
            }
        });
    }

    function _getQSFromParams(context) {
        var baseUrl = context.hasBaseUrl() ? context.getBaseUrl() : window.location.pathname;

        if (!context.hasAnyFilters() && !context.hasSortOrder()) {
            return baseUrl;
        }

        var uriParts = [];

        context.forEachFilter(function(filterName, values) {
            if (values.length === 0) return;
            // excape the hash symbol in filters.
            var updatedValues = values.join("~").replaceAll("#", HASH_ENCOUDING);
            uriParts.push(filterName + "=" + updatedValues);
        });

        var sortOrder = context.getSortOrder();
        if (sortOrder.length == 2) {
            uriParts.push("sort=" + sortOrder[0] + "-" + sortOrder[1]);
        }

        var quantifiers = {};
        context.forEachFilterQuantifier(function(filterName, quantifier) {
            if (!quantifier) return;
            if (quantifier == 'any') return;
        
            var key = 'quantifiers.' + quantifier;

            if (!quantifiers[key]) {
                quantifiers[key] = [];
            }

            quantifiers[key].push(filterName);
        });
        
        for (var key in quantifiers) {
            if (quantifiers[key].length > 0) {
                uriParts.push(key + '=' + quantifiers[key].join('~'));
            }
        }

        if (uriParts.length == 0) return '';

        return baseUrl + '?' + uriParts.join('&');
    }

    return urlStorageComponent;
});

